import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ReactiveFormsModule, FormsModule, FormGroup } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { CamelCasePipe } from '../../../utils/camel-case.pipe';
import { FormFieldConfig, FieldSelectedValue } from '../../../model/form.model';

@Component({
  selector: 'app-mat-textarea',
  standalone: true,
  imports: [MatInputModule, CommonModule, CamelCasePipe,ReactiveFormsModule, MatSelectModule, FormsModule],
  templateUrl: './mat-textarea.component.html',
  styleUrl: './mat-textarea.component.scss'
})
export class MatTextareaComponent implements OnInit {
  @Input()
  field!: FormFieldConfig;
  @Input() form!: FormGroup;
  @Output() inputChanged = new EventEmitter<FieldSelectedValue>();
  ngOnInit() {
    this.field.selectedValue ??= '';
  }
  onTextChange(FieldName: string, event: any): void {
    if (this.field) {
      const inputValue = (event.target.value).trim();
      this.field['selectedValue'] = inputValue;
      this.inputChanged.emit({
        FieldName: FieldName,
        Value: inputValue,
      });
    }
  }
}